import createCachedSelector from 're-reselect';

import { State } from '../../typings/state';
import { StrategyEditorData } from '../../typings/strategyEditor';

export const selectStrategyEditorData = createCachedSelector(
    (state: State, editorId: string): StrategyEditorData =>
        state.strategyEditor.editors[editorId],
    (editorData: StrategyEditorData): StrategyEditorData => editorData
)((state: State, editorId: string): string => editorId);
